export enum HomeboundStatusEnum {
  Homebound = 1,
  NotHomebound = 2
}

export const HomeboundStatusOptions = [
{ id: 1, label: 'Homebound' },
{ id: 2, label: 'Not Homebound' }
];
